module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Solo-A-Star-Wars-Story.600941d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Solo-A-Star-Wars-Story.jpg
// module id = 1f+l
// module chunks = 0